/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Driver_Remittance_Invalid_MethodInputs */

const vi_error_driver_remittance_invalid_method = /** @type {(inputs: Error_Driver_Remittance_Invalid_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn tài xế đưa lại bằng tiền mặt hay chuyển khoản.`)
};

/**

* @param {Error_Driver_Remittance_Invalid_MethodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_driver_remittance_invalid_method = /** @type {((inputs?: Error_Driver_Remittance_Invalid_MethodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Driver_Remittance_Invalid_MethodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_driver_remittance_invalid_method(inputs)
});